//============================================================================
// Name        : SearchProduct.tsx
// Purpose     : Implement Production Schedule search page
// Created     : 2019-08-09
// Author      : Senitron Team
// Copyright   : Copyright 2019 Senitron Corporation. All rights reserved.
//============================================================================

// tslint:disable-next-line: no-unused-expression
/** @jsx jsx */ jsx;
import { css, jsx } from "@emotion/core";
import axios from "axios";
import React from "react";
import { ChangeInputEvent, IProduct, ISearchProductProps, ISearchProductState } from "./types";

const actionsTd = css`
    text-align: right;
`;

class SearchProduct extends React.Component<ISearchProductProps, ISearchProductState> {
    constructor(props: any) {
        super(props);
        this.state = {
            query: "",
            products: new Array<IProduct>()
        };
    }

    onChange = (event: ChangeInputEvent) => {
        const newState = { [event.target.name]: event.target.value };
        this.setState(newState as unknown as ISearchProductState);
    }
    shouldSearch = (e) => {
        if (e.key == "Enter") {
            this.onSearch();
        }
    }
    onSearch = async () => {
        // Don't search with an empty field
        if (this.state.query.trim().length == 0) {
            return;
        }

        const resp = await axios.get(this.props.searchUrl + `?search=${this.state.query}`);
        this.setState({ products: resp.data as IProduct[] });
    }
    getScheduleUrl = (itemId: number) => `${this.props.scheduleUrl}?id=${itemId}`;

    render() {
        return (
            <React.Fragment>
                {/* Search */}
                <div className="center-row">
                    <div className="search-container">
                        <div>
                            <input type="text" id="searchField" name="query" value={this.state.query} onChange={this.onChange} onKeyPress={this.shouldSearch} />
                            <button className="man-btn" id="searchBtn" onClick={this.onSearch}>
                                <i className="fa fa-search"></i>
                            </button>
                        </div>
                        <div className="legend">Search by Item Name or Part#</div>
                    </div>
                </div>
                {/* /Search */}

                {/* Search Results */}
                <div className="row search-content-row">
                    <div className="table-responsive col-md-12">
                        <table className="table table-bordered table-striped searchTable">
                            <thead className="thead-inverse">
                                <tr>
                                    <th>Item #</th>
                                    <th>Item Description</th>
                                    <th css={{ width: 495 }}>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                            {this.state.products.map((product: IProduct, key) =>
                                <tr key={key}>
                                    <td>{product.alu}</td>
                                    <td>{product.description}</td>
                                    <td css={actionsTd}>
                                        <a href={this.getScheduleUrl(product.id)} className="man-btn man-green-btn">
                                            Check Current &amp; Future Inventory | Schedule Production
                                        </a>
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
                {/* /Search Results */}
            </React.Fragment>
        );
    }
}

export default SearchProduct;
